import {
    BulletinListExportExcelRequest
} from '../../../../../../../infrastructure/remote/sacmi/dto/request/BulletinListExportExcelRequest';
import {BulletinListFilters} from '../../../../../view/useBulletinListFilters';

const ExportBulletinListExcelDataMapper = {
    fromDomain(bulletinIds: string[], filters: BulletinListFilters): BulletinListExportExcelRequest {
        return {bulletin_ids: bulletinIds, ...filters};
    }
}

export default ExportBulletinListExcelDataMapper;
